<template>
	<div id="subpageDiv">
		<div class="subBanner" style="background:url(/images/subBg06.png) center center no-repeat">
			<div class="w1200">
				<div class="subTitle">
					<em>Innovative Practice</em>
					<span>创新实践</span>
					<img src="/images/line.png" class="line" />
				</div>
			</div>
		</div>
		<div class="w1200">
			<itemsearch v-bind:colid='colid' v-bind:colname='colname' @searchshow="searchshow" @searchclose="searchclose"></itemsearch>
			<div v-show="!searchResultShow">
				<el-skeleton :rows="20" :loading="loadingMask" animated :throttle="500">	
		    <ul class="newList">
		        <li v-for="(result,index) in resultDataList">
		        	<router-link :to="{ name: 'detail', params: { id: result.id }}" target="_blank" @click.native="$track([['pagetype',colname+'-文章-id:'+result.id+'-点击']])">
		        		{{result.title}}<i></i></router-link>
		        	<p>{{result.summary.indexOf('attachment id=')>-1?' ':result.summary}}</p>
		        	<em>{{result.publishtime?result.publishtime.substring(0,10):''}}</em>
		        </li>
		    </ul>
				</el-skeleton>
		    
		    <div class="pagediv">
		    	<el-pagination
		    				@size-change="changePageSize"
		    				@current-change="changeSearchPage"
		    				:current-page="pageNum"
		    				:page-sizes="[10, 15, 20]"
		    				:page-size="pageSize"
		    				layout="total, sizes, prev, pager, next, jumper"
		    				:total="totalResultCount">
		    			</el-pagination>
		    </div>
			</div>
		</div>
	</div>
</template>

<script>
	import itemsearch from '@/components/list-item-search.vue'
	export default {
		data() {
			return {
				loadingMask: true,
				colid: '35f62e0da7c44340b7163804ceb28e70',
				colname:'创新实践',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
				searchResultShow:false,
				searchKey:'',
			}
		},
		components:{
			itemsearch,
		},
		created: function() {

		},
		mounted: function() {
			document.title = '实践-数字中国专版';
			this.$track([
				['pagetype', '实践列表'],
				['reqtype', '2'],
				['column', this.colid]
			]);
			this.searchfnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID: this.colid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy: 'publishtime',
							isDesc: '1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = document.getElementById('subpageDiv').offsetTop;
				document.documentElement.scrollTop = document.getElementById('subpageDiv').offsetTop;
			},
			searchshow:function(key){
				this.searchResultShow=true;
			},
			searchclose:function(){
				this.searchResultShow=false;
			}
		}
	}
</script>

<style>
</style>
